import { atom } from "jotai";
import type { UseApiLoaderResponse } from "../../../server/api/hooks/use-api-loader";
import type { Multiformat } from "./types";

export const multiformatAtom = atom<UseApiLoaderResponse<Multiformat | null>>({
  loading: false,
  error: null,
  data: null,
  reload: () => {},
});
